import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const AirbagPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="airbag" />;
};

export default AirbagPage;